import { css, StyleDeclarationValue } from 'aphrodite';
import { useId } from 'react';
import { useAdminAccountStats } from '../../../queries/Admin/Account/useAdminAccountStatsQuery';
import { IAccountFilterCriteria } from '../../../viewmodels/AdminViewModels';
import { Checkbox } from '../../../web/components-v2/Checkbox';
import { FlagIcon } from '../../../web/components/svgs/icons/FlagIcon';
import { styleSheet } from './styles';

interface IProps {
	filterCriteria: IAccountFilterCriteria;
	className?: string;
	flaggedCheck?: boolean;
	greenCheck?: boolean;
	greyCheck?: boolean;
	onChangedFlaggedCheck?(): void;
	onChangedGreenCheck?(): void;
	onChangedGreyCheck?(): void;
	onChangedOrangeCheck?(): void;
	onChangedRedCheck?(): void;
	onChangedYellowCheck?(): void;
	orangeCheck?: boolean;
	redCheck?: boolean;
	styles?: StyleDeclarationValue[];
	yellowCheck?: boolean;
	totalNumberOfResults?: number;
}

export function AccountsStatsHeader({
	filterCriteria,
	className,
	flaggedCheck,
	greenCheck,
	greyCheck,
	onChangedFlaggedCheck,
	onChangedGreenCheck,
	onChangedGreyCheck,
	onChangedOrangeCheck,
	onChangedRedCheck,
	onChangedYellowCheck,
	orangeCheck,
	redCheck,
	styles,
	yellowCheck,
	totalNumberOfResults,
}: IProps) {
	const id = useId();
	const adminAccountStats = useAdminAccountStats({
		filter: filterCriteria,
	});

	const validGreenAccountsPercent =
		adminAccountStats.data && adminAccountStats.data.greenAccountsPercentage >= 0
			? adminAccountStats.data.greenAccountsPercentage
			: undefined;
	const validYellowAccountsPercent =
		adminAccountStats.data && adminAccountStats.data.yellowAccountsPercentage >= 0
			? adminAccountStats.data.yellowAccountsPercentage
			: undefined;
	const validOrangeAccountsPercent =
		adminAccountStats.data && adminAccountStats.data.orangeAccounts >= 0
			? adminAccountStats.data.orangeAccountsPercentage
			: undefined;
	const validRedAccountsPercent =
		adminAccountStats.data && adminAccountStats.data.redAccountsPercentage >= 0
			? adminAccountStats.data.redAccountsPercentage
			: undefined;

	return (
		<div className={`${css(styleSheet.accountsStatsHeader, ...(styles || []))} ${className || ''}`}>
			<div className={css(styleSheet.accountsTitle)}>
				<span className={css(styleSheet.accountTotalNumber)}>
					{totalNumberOfResults >= 0 ? totalNumberOfResults : '--'}
				</span>
				<div className={css(styleSheet.accountTotalDesc)}>Total Accounts</div>
			</div>
			<div className={css(styleSheet.accountsTitle)}>
				{adminAccountStats.data?.activeAccountsPercentage >= 0 && (
					<>
						<span className={css(styleSheet.accountActiveNumber)}>
							{adminAccountStats.data?.activeAccountsPercentage.toString() + '%'}
						</span>
						<div className={css(styleSheet.accountTotalDesc)}>Active Accounts</div>
					</>
				)}
			</div>
			<div className={css(styleSheet.checkboxContainer)}>
				<div className={css(styleSheet.checkboxFilter)}>
					<Checkbox id={`${id}-gray`} size='lg' onCheckedChange={onChangedGreyCheck} checked={greyCheck} />
					<label htmlFor={`${id}-gray`}>Gray</label>
				</div>
				<div className={css(styleSheet.checkboxFilter)}>
					<Checkbox id={`${id}-green`} size='lg' onCheckedChange={onChangedGreenCheck} checked={greenCheck} />
					<label htmlFor={`${id}-green`} className={css(styleSheet.green)}>
						Green
					</label>
					{validGreenAccountsPercent >= 0 ? (
						<span className={css(styleSheet.percentLabel)}>{validGreenAccountsPercent} %</span>
					) : null}
				</div>
				<div className={css(styleSheet.checkboxFilter)}>
					<Checkbox id={`${id}-yellow`} size='lg' onCheckedChange={onChangedYellowCheck} checked={yellowCheck} />
					<label htmlFor={`${id}-yellow`} className={css(styleSheet.yellow)}>
						Yellow
					</label>
					{validYellowAccountsPercent >= 0 ? (
						<span className={css(styleSheet.percentLabel)}>{validYellowAccountsPercent} %</span>
					) : null}
				</div>
				<div className={css(styleSheet.checkboxFilter)}>
					<Checkbox id={`${id}-orange`} size='lg' onCheckedChange={onChangedOrangeCheck} checked={orangeCheck} />
					<label htmlFor={`${id}-orange`} className={css(styleSheet.orange)}>
						Orange
					</label>
					{validOrangeAccountsPercent >= 0 ? (
						<span className={css(styleSheet.percentLabel)}>{validOrangeAccountsPercent} %</span>
					) : null}
				</div>
				<div className={css(styleSheet.checkboxFilter)}>
					<Checkbox id={`${id}-red`} size='lg' onCheckedChange={onChangedRedCheck} checked={redCheck} />
					<label htmlFor={`${id}-red`} className={css(styleSheet.red)}>
						Red
					</label>
					{validRedAccountsPercent >= 0 ? (
						<span className={css(styleSheet.percentLabel)}>{validRedAccountsPercent} %</span>
					) : null}
				</div>
				<div className={css(styleSheet.checkboxFilter)}>
					<Checkbox id={`${id}-flagged`} size='lg' onCheckedChange={onChangedFlaggedCheck} checked={flaggedCheck} />
					<label htmlFor={`${id}-flagged`} className={css(styleSheet.flagged)}>
						Flagged
						<FlagIcon isAccount={true} flagged={true} />
					</label>
				</div>
			</div>
		</div>
	);
}
